import FavoriteButton from '@liveauctioneers/caterwaul-components/lib/FavoriteButton/FavoriteButton';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { EventContext } from '@/redux/modules/analytics';
import { toggleItemSave } from '@/redux/modules/item/saved/savedItems.actions';
import { isItemSaved } from '@/redux/modules/item/saved/savedItems.selectors';
import { CompleteAccountModalContext, ModalContext } from '@/redux/modules/modal';
import { ButtonLocation } from '@/utils/amplitude/analytics';

type Props = {
    catalogId: number;
    imageUrl: string;
    itemId: number;
    itemUnavailable: boolean;
};

// TODO wait for API that get's the more current data
// type BidderLotStatus = '' | 'leading' | 'won' | 'lost' | 'outbid';

const LotImageContainer = ({ catalogId, imageUrl, itemId, itemUnavailable }: Props) => {
    // TODO wait for API that get's the more current data
    // const { bidderHasBid, bidderHasHighBid, bidderWonItem, isSold } = useAppSelector((state) =>
    //     getItemSummary(state, itemId)
    // );

    const dispatch = useAppDispatch();
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const isFavorite = useAppSelector((state) => isItemSaved(state, itemId));
    const location = useLocation();

    const modalContext = useMemo<ModalContext>(
        () => ({
            eventContext: EventContext.saveItem,
            id: itemId,
            itemId,
            type: CompleteAccountModalContext.SaveItem,
        }),
        [itemId]
    );

    // TODO wait for API that get's the more current data
    // // Data for live item
    // const currentLiveItemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    // const currentBidderId = useAppSelector(getBidderId);
    // const leadingBidder = useAppSelector((state) => getLiveItemDataLeadingBidder(state, itemId));
    // const liveBidderHasHighBid = useAppSelector((state) => getBidderHasHighBid(state));
    // const myBid = leadingBidder === currentBidderId;
    // const isCurrentLiveItem = currentLiveItemId === itemId;
    // // console.log(isCurrentLiveItem);

    const onToggleFavorite = useCallback(() => {
        dispatch(
            toggleItemSave({
                buttonLocation: ButtonLocation.LotTracker,
                canHaveEasyShippingTag: false,
                catalogId,
                itemId,
                location,
            })
        );
    }, [dispatch, itemId, catalogId, location]);

    // TODO wait for API that get's the more current data
    // let statusMessage: BidderLotStatus = '';
    // if ((bidderHasHighBid || myBid) && !isSold) {
    //     statusMessage = 'leading';
    // } else if ((isSold && bidderHasHighBid) || bidderWonItem) {
    //     statusMessage = 'won';
    // } else if (!bidderHasHighBid && isSold) {
    //     statusMessage = 'lost';
    // } else if (!bidderHasHighBid && !isSold) {
    //     statusMessage = 'outbid';
    // }

    // console.log({
    //     liveBidderHasHighBid,
    //     myBid,
    // });

    // const showStatus = bidderHasBid || myBid;

    return (
        <div
            className={cn(
                'relative mr-sm inline-flex h-[78px] min-h-[78px] w-[78px] min-w-[78px] items-center justify-center'
            )}
        >
            {!isFavorite && (
                <div className="heart-icon absolute right-2xs top-2xs z-[2] hidden">
                    <ShouldLogInContainer
                        forceSignUp={!userLoggedIn}
                        modalContext={modalContext}
                        runFunction={onToggleFavorite}
                    >
                        <FavoriteButton data-testid="favorite-button" />
                    </ShouldLogInContainer>
                </div>
            )}
            {isFavorite && (
                <div className="absolute right-2xs top-2xs z-[2] block">
                    <FavoriteButton
                        data-testid="unfavorite-button"
                        onClick={onToggleFavorite}
                        selected
                    />
                </div>
            )}
            <img
                className={cn('h-full w-full object-contain', { 'opacity-50': itemUnavailable })}
                data-testid="lot-image"
                src={imageUrl}
            />

            {/*  TODO wait for API that get's the more current data */}
            {/* {showStatus && (
                <StatusContainer $status={statusMessage}>
                    <Status>{statusMessage}</Status>
                </StatusContainer>
            )} */}
        </div>
    );
};

export default LotImageContainer;

// const StatusContainer = styled.div<{ $status: BidderLotStatus }>`;
//     position: absolute;
//     bottom: 0;
//     width: 100%;
//     height: fit-content;
//     text-align: center;
//     ${({ $status }) => {
//         if ($status === 'won' || $status === 'leading') {
//             return css`
//                 background: ${({ theme }) => theme.colors.green100};
//             `;
//         }
//         if ($status === 'outbid') {
//             return css`
//                 background: ${({ theme }) => theme.colors.red100};
//             `;
//         }
//         if ($status === 'lost') {
//             return css`
//                 background: ${({ theme }) => theme.colors.grey100};
//             `;
//         }
//     }}
// `;

// const Status = styled(Text)`
//     color: ${({ theme }) => theme.colors.white};
//     letter-spacing: 1px;
//     font-size: 12px;
//     font-weight: 500;
//     text-transform: uppercase;
// `;
